import { render } from "./CourseAdministratorShortCard.vue?vue&type=template&id=477752c6"
import script from "./CourseAdministratorShortCard.vue?vue&type=script&lang=js"
export * from "./CourseAdministratorShortCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__